export const possession = [
  {
    id: 1,
    category: 'featured_players.possession.successful_passes',
    category_id: [2, 20],
    singleName: 'Pase acertado',
  },
  {
    id: 2,
    category: 'featured_players.possession.successful_passes_opponents_half',
    category_id: [20],
    singleName: 'Pase acertado c. rival',
  },
  {
    id: 3,
    category: 'featured_players.possession.successful_passes_own_half',
    category_id: [2],
    singleName: 'Pase acertado c. propia',
  },
  {
    id: 4,
    category: 'featured_players.possession.recovered_balls',
    category_id: [482],
    singleName: 'Balón recuperado',
  },
  {
    id: 5,
    category: 'featured_players.possession.balls_recovered_in_challenge',
    category_id: [485, 486, 489, 490],
    singleName: 'B. recuperado en disputa',
  },
];

export const offensive = [
  {
    id: 1,
    category: 'featured_players.offensive.shots_on_goal',
    category_id: [510],
    singleName: 'Tiro a gol',
  },
  {
    id: 2,
    category: 'featured_players.offensive.centers_from_right',
    category_id: [25],
    singleName: 'Centro por derecha',
  },
  {
    id: 3,
    category: 'featured_players.offensive.centers_from_left',
    category_id: [13],
    singleName: 'Centro por izquierda',
  },
  {
    id: 4,
    category: 'featured_players.offensive.successful_1_on_1',
    category_id: [4],
    singleName: '1 vs 1 exitoso ofensivo',
  },
  {
    id: 5,
    category: 'featured_players.offensive.balls_won_opponent_penalty_box',
    category_id: [11],
    singleName: 'B. ganado en área rival',
  },
];

export const defensive = [
  {
    id: 1,
    category: 'featured_players.defensive.balls_recovered',
    category_id: [482],
    singleName: 'Balón recuperado',
  },
  {
    id: 19,
    category: 'featured_players.defensive.balls_recovered_opponents_half',
    category_id: [491, 492, 487, 488],
    singleName: 'B. recuperado C. rival',
  },
  {
    id: 3,
    category: 'featured_players.defensive.balls_won_own_penalty_box',
    category_id: [23],
    singleName: 'B. ganado área propia',
  },
  {
    id: 4,
    category: 'featured_players.defensive.clearances',
    category_id: [34],
    singleName: 'Rechace',
  },
  {
    id: 5,
    category: 'featured_players.defensive.successful_1_on_1',
    category_id: [5],
    singleName: '1 vs 1 exitoso defensivo',
  },
];

export const allCategories = (function() {
  const allCategoriesArray = [...possession, ...offensive, ...defensive];
  allCategoriesArray.forEach(category => {
    category.categories = category.category_id;
  });
  return allCategoriesArray;
})();
